import React, { useCallback, useMemo } from 'react';
import { LeadCardType } from '@zola/zola-ui/src/paper/cards/constants/cardTypes';
import type { SearchFilters } from 'cards/components/CardListing/CardListingRedesign/CardListingFilter/FilterTypes';
import { FilterBubbleItem } from './types';
import { STYLE_FILTER_BUBBLES } from './constants';
import { BubblesRow, BubbleWrapper, BubbleImage, BubbleLabel } from './FilterBubbles.styles';

type BubbleProps = {
  item: FilterBubbleItem;
  applyFilters: (newFilters: Partial<SearchFilters>) => void;
};

const Bubble: React.FC<BubbleProps> = ({ item, applyFilters }) => {
  const { image, filters, label, href } = item;

  const imgStyles: React.CSSProperties = useMemo(
    () => ({
      backgroundImage: `url(${image})`,
    }),
    [image]
  );

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();

      if (filters) {
        applyFilters(filters);
      } else if (href) {
        window.location.href = href;
      }
    },
    [applyFilters, filters, href]
  );

  return (
    <BubbleWrapper href={href} onClick={handleClick}>
      <BubbleImage style={imgStyles} />
      <BubbleLabel>{label}</BubbleLabel>
    </BubbleWrapper>
  );
};

type FilterBubblesProps = {
  activeCardEvent: LeadCardType;
  overwriteFilters: (newFilters: Partial<SearchFilters>) => void;
};

export const FilterBubbles: React.FC<FilterBubblesProps> = ({
  activeCardEvent,
  overwriteFilters,
}) => {
  const filterItems = STYLE_FILTER_BUBBLES[activeCardEvent];

  if (!filterItems) return null;

  return (
    <BubblesRow>
      {filterItems.map(item => {
        return <Bubble key={item.label} item={item} applyFilters={overwriteFilters} />;
      })}
    </BubblesRow>
  );
};
